import React from 'react';
import PropTypes from 'prop-types';

import { InsOutsPlayer } from './InsOutsPlayer';

/**
 * Renders the wrapper and title for both teams.
 *
 * @param data.data
 * @param {object} data The Ins/Outs player data.
 * @param {string} title The value printed to the section, i.e. 'IN' or 'OUT'.
 * @param {string} matchTitle The match title, e.g. 'Sydney Swans v GWS GIANTS'.
 * @param {string} cssClass The CSS class that is applied to the title, i.e. 'in' or 'out'.
 * @param data.title
 * @param data.cssClass
 * @param data.matchTitle
 * @returns {JSX.Element} The Ins/Outs row for both teams.
 */
export const InsOutsRowBoth = ({ data, title, matchTitle, cssClass }) => {
    const renderPlayer = (item, match) => {
        if (!item) {
            return null;
        }

        const player = item.player ? item.player : item;

        return (
            <InsOutsPlayer
                key={player.playerId}
                data={data}
                player={player}
                reason={item.reason}
                match={match}
                matchTitle={matchTitle}
            />
        );
    };

    return (
        <div className="team-lineups-condensed-embeddable__ins-and-outs team-lineups-condensed-embeddable__ins-and-outs--both">
            <div className="team-lineups__title-section u-hide-from-tablet">
                <div className="team-lineups-ins-and-outs__title-wrapper ">
                    <p
                        className={`team-lineups-ins-and-outs__title ${
                            cssClass
                                ? `team-lineups-ins-and-outs__title--${cssClass}`
                                : ''
                        }`}
                    >
                        {title}
                    </p>
                </div>
            </div>
            <div className="team-lineups__grid">
                {data.home.length ? (
                    <div className="team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--home">
                        {[...data.home]
                            .reverse()
                            .map((item) => renderPlayer(item, data))}
                    </div>
                ) : (
                    <span className="team-lineups-ins-and-outs__empty team-lineups-ins-and-outs__empty--home">
                        &ndash;
                    </span>
                )}
                <div className="team-lineups__title-section u-hide-until-tablet">
                    <div className="team-lineups-ins-and-outs__title-wrapper">
                        <p
                            className={`team-lineups-ins-and-outs__title ${
                                cssClass
                                    ? `team-lineups-ins-and-outs__title--${cssClass}`
                                    : ''
                            }`}
                        >
                            {title}
                        </p>
                    </div>
                </div>
                {data.away.length ? (
                    <div className="team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--away">
                        {data.away.map((item) =>
                            renderPlayer(item, data.match)
                        )}
                    </div>
                ) : (
                    <span className="team-lineups-ins-and-outs__empty team-lineups-ins-and-outs__empty--away">
                        &ndash;
                    </span>
                )}
            </div>
        </div>
    );
};

InsOutsRowBoth.propTypes = {
    data: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    matchTitle: PropTypes.string.isRequired,
    cssClass: PropTypes.string
};
